import { numToDecimals, roundNumberAndDecimals } from '@teinor/erp/prices';
import { baseCalculateParams } from '@teinor/erp/prices/quote/calculate';
import { TwinDictionary } from '../../../../../../../../utils/globals/dictionary';
import { stringMatchWithSearch } from '../../../../../../../../utils/globals/search';
import { OrderData, OrderTableScaleRelation } from '../../../../types';
import { DictEditProductAddonOrder } from './types';

export const sortTableDataByNLines = (tableData: TwinDictionary[], referenceOrder?: TwinDictionary) => {
    return tableData.sort((a, b) => {
        if (a.nLine === undefined && b.nLine === undefined) {
            if (referenceOrder) {
                if (parseFloat(referenceOrder[a.ProductId] || 0) > parseFloat(referenceOrder[b.ProductId] || 0)) {
                    return 1
                } else {
                    return -1
                }
            }
            return 0
        }
        return a.nLine === undefined ? 1 : a?.nLine > (b?.nLine || Infinity) ? 1 : -1
    })
}

export const checkIfScale = (data: DictEditProductAddonOrder, ScaleByProductId: number, parentProduct: TwinDictionary, createIfNotExists?: boolean) => {
    if (data?.suscribedLines?.[ScaleByProductId]) {
        const arrToUpdate = data?.suscribedLines?.[ScaleByProductId]
        for (const element of arrToUpdate) {
            const info = element.split('-')
            const productAddonChild = data?.productAddons?.[info[0]].elements[info[1]]
            let parsedQuantity = parseFloat(String(productAddonChild.quantity || '0'))
            if ((parsedQuantity > 0 && productAddonChild.updateQuantity) || (productAddonChild.quantity === null && productAddonChild.createDefault)) {
                const parsedScaleQuantity = parseFloat(String(productAddonChild.scaleQuantity))
                const parsedParentQuantity = parseFloat(String(parentProduct.quantity || '0'))
                productAddonChild.quantity = numToDecimals(parsedScaleQuantity * parsedParentQuantity * (productAddonChild.multiplyByWeight ? parseFloat(String(parentProduct.quantity2base)) : 1), 8)
                productAddonChild.calculatedQuantity = numToDecimals(productAddonChild.quantity + (productAddonChild.quantity * (productAddonChild.wasteWeight || 0) / 100), 8)
                productAddonChild.updateQuantity = true
                checkIfScale(data, productAddonChild?.ProductAddonId, productAddonChild, createIfNotExists)
            }
        }
    }
    return data
}

export const updateTableQuantityScaled = (data: OrderData, OrderProductId: number, quantityProduct: number) => {
    const relatedProducts: TwinDictionary[] = []
    if (data?.scaleByProduct?.[OrderProductId]) {
        for (const element of data?.scaleByProduct?.[OrderProductId]) {
            prepareRelatedProductForScale(data, element, quantityProduct, relatedProducts)
        }
    }
    return relatedProducts
}

export const updateTableQuantityScaledByWeight = (data: OrderData, OrderProductId: number, quantity2Product: number) => {
    const relatedProducts: TwinDictionary[] = []
    if (data?.scaleByProductWeight?.[OrderProductId]) {
        for (const element of data?.scaleByProductWeight?.[OrderProductId]) {
            prepareRelatedProductForScale(data, element, quantity2Product, relatedProducts)
        }
    }
    return relatedProducts
}

export const updateVariableQuantityScaled = (data: OrderData, field: string, quantityVariable: any) => {
    const relatedProducts: TwinDictionary[] = []
    if (data?.scaleByVariable?.[field]) {
        for (const element of data?.scaleByVariable?.[field]) {
            prepareRelatedProductForScale(data, element, quantityVariable, relatedProducts)
        }
    }
    return relatedProducts
}

const prepareRelatedProductForScale = (data: OrderData, element: OrderTableScaleRelation, quantity: string | number, relatedProducts: TwinDictionary[]) => {
    const myTableData = data.tableData?.[element.index]
    const _oldQuantity = myTableData.quantity
    let calculatedQuantity = 0
    const parsedQuantity = parseFloat(String(quantity))
    const myQuantity = numToDecimals(parsedQuantity * element.scaleQuantity, 8)
    myTableData.quantity = String(myQuantity)
    if (myTableData.wasteWeight) {
        const myWasteWeight = parseFloat(String(myTableData.wasteWeight))
        calculatedQuantity = numToDecimals(((myWasteWeight * myQuantity / 100) + myQuantity) , 8)
    }
    myTableData.calculatedQuantity = myTableData.wasteWeight ? calculatedQuantity : myQuantity
    let myQuantity2 = 0
    if (myTableData.quantity2base) {
        myQuantity2 = numToDecimals(myTableData['quantity2base'] * parseFloat(myTableData.quantity), 8)
    }
    myTableData['quantity2'] = myQuantity2
    relatedProducts.push(({
        _oldQuantity,
        id: myTableData.id,
        initialUnitPriceWithoutTax: myTableData.initialUnitPriceWithoutTax,
        isParent: myTableData.isParent,
        nLine: myTableData.nLine,
        OrderId: myTableData.OrderId,
        OrderProductId: myTableData.OrderProductId,
        ProductId: myTableData.ProductId,
        quantity: myTableData.quantity,
        calculatedQuantity: myTableData.calculatedQuantity,
        taxUsed: myTableData.taxUsed,
        quantity2: myTableData.quantity2,
        desiredQuantity: myTableData.desiredQuantity
    }))
    const myRelatedProducts: any[] = updateTableQuantityScaled(data, myTableData.id, myTableData.quantity)
    const myRelatedProductsWeight: any[] = updateTableQuantityScaledByWeight(data, myTableData.id, myTableData.quantity2)
    relatedProducts.push(...myRelatedProducts)
    relatedProducts.push(...myRelatedProductsWeight)
}

export const updateQuantityScaled = (data: DictEditProductAddonOrder, productAddon: TwinDictionary) => {
    if (data?.parentLines?.[productAddon.ScaleByProductId]){
        const positionParent = data?.parentLines?.[productAddon.ScaleByProductId]?.split('-')
        const parentProduct = data?.productAddons?.[positionParent[0]]?.elements[positionParent[1]]
        if (parentProduct && parentProduct.quantity) {
            const myQuantityCalc = productAddon.multiplyByWeight ? parseFloat(parentProduct.quantity2) : parseFloat(parentProduct.quantity)
            productAddon.quantity = numToDecimals(myQuantityCalc * parseFloat(String(productAddon.scaleQuantity)), 8)
            productAddon.calculatedQuantity = roundNumberAndDecimals(productAddon.quantity + ((productAddon.wasteWeight || 0) * productAddon.quantity / 100), baseCalculateParams)
            productAddon.quantity2 = roundNumberAndDecimals(productAddon.quantity * parseFloat(productAddon.quantity2base || '0'), baseCalculateParams)
        }
    }
}

export const updateQuantityScaledVariables = (data: DictEditProductAddonOrder, productAddon: TwinDictionary) => {
    if (data?.suscribedVariables?.[productAddon.ProductAddonId]) {
        productAddon.quantity = data?.suscribedVariables?.[productAddon.ProductAddonId]
    }
}

export const showCheckboxUpdateQuantity = (productAddon: TwinDictionary, data: DictEditProductAddonOrder) => {
    if (parseFloat(productAddon.quantity) > 0 && productAddon?.ScaleByProductId){
        if (data?.parentLines?.[productAddon.ScaleByProductId]) {
            const positionParent = data?.parentLines?.[productAddon.ScaleByProductId]?.split('-')
            const parentProduct = data?.productAddons?.[positionParent[0]]?.elements?.[positionParent[1]]
            if (parentProduct?.quantity) {
                return true
            }
        }
    } else if (parseFloat(productAddon.quantity) > 0 && productAddon?.ScaleByVariableId) {
        return true
    }
    return false
}

export const filterElementsBySearchEditAddonProducts = (elements: TwinDictionary[], searchValue: string) => {
    if(searchValue ===''){
        return elements
    }
    const result: TwinDictionary[] = []
    for (const element of elements) {
        if (stringMatchWithSearch(searchValue, element.fullName)) {
            result.push(element)
        }
    }
    return result
}